import React, { useContext } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { AuthContext } from "../Auth";
import useAuthAxios from "../useAuthAxios";
import { removeCookie } from "./Action/HandleCookie"

export default function Logout() {
    const navigate = useNavigate();
    const { auth } = useContext(AuthContext);
    const authAxios = useAuthAxios();
    const headers = {
        "Authorization": "Bearer " + auth,
        'Content-Type': 'application/json',
    };
    const loginType = localStorage.getItem("loginType");

    React.useEffect(() => {
        authAxios.post('api/authenticate/logout', "", { headers })
            .then((response) => {
                if (response.status === 200) {
                    localStorage.removeItem("Auth");
                    localStorage.removeItem('use')
                    localStorage.removeItem('contractListOpe')
                    localStorage.removeItem('contractDelete')
                    localStorage.removeItem('contractConfigOpe')
                    localStorage.removeItem('internalApproval')
                    localStorage.removeItem('internalConfirm')

                    localStorage.removeItem('UseInspection')
                    localStorage.removeItem('inspectionRecordDelete')
                    localStorage.removeItem('inspectionVendorEdit')
                    localStorage.removeItem('UserShitenCD')
                    removeCookie("authorization")
                    removeCookie("userName")
                    removeCookie("userShozokuName")

                    localStorage.removeItem("pdfjs.history");

                    sessionStorage.removeItem('shortTermSearchCondition');
                    sessionStorage.removeItem('longTermSearchCondition');
                    sessionStorage.removeItem('visitReportSearchCondition');
                    sessionStorage.removeItem('vendorAccountSearchCondition');
                    sessionStorage.removeItem('contractSearchCondition');

                    switch (loginType) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/OMSUser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    switch (loginType) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/OMSUser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                } else {
                    alert("認証情報削除に失敗しました。");
                    switch (loginType) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/OMSUser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                }
            });

    });

    return (

        <Container component="main" maxWidth="lg" sx={{ mb: 1 }}>
            <Grid container spacing={3} >
                <Grid item xs={8} >
                    <Typography sx={{ color: 'text.primary' }} >
                        ログアウトしました。
                    </Typography>
                </Grid>

            </Grid>
        </Container>
    );
}
